import React from 'react';

import './styles.css';

import { Dots } from "react-activity";

export default function ClassPaymentsCardInfo(props) {
    return (
        <span className={'class-section-card-info' + (props.button ? ' button' : '')}>
            <p className='info-tittle'>{props.tittle}</p>
            {props.data !== null && props.data !== undefined ? <p className='info-data'>{props.data}</p> : <Dots />}
        </span>
    )
}